import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import moment from "moment";

import { useUser, usePopup, useData, useMenu, useLang, useLoading } from "../zustand/store.js";

import { LangText } from "../zustand/dict.js";
import consts from '../libs/consts';
import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import InputSimple from '../components/InputSimple.js';
import Button from '../components/Button';
import Selector from '../components/Selector';
import RadioImage from "../components/RadioImage";
import Radio from "../components/Radio";
import InputRange from "../components/InputRange";

import * as APIS from '../utils/service.js'
import Modal from "../components/Modal.js";
import { loadImage } from "../utils/utils.js";

// 영상 분위기 보정
export default function Menu9() {
    const navigate = useNavigate();
    const location = useLocation();

    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();

    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const { setLoading } = useLoading();

    const [config, setConifg] = useState({});
    const [configError, setConfigError] = useState(false);
    const [limitSize, setLimitSize] = useState(10000000000)

    const [video, setVideo] = useState("");
    const [videoError, setVideoError] = useState(false);
    const [videoInfoError, setvideoInfoError] = useState(false);
    const [mediaInfo, setMediaInfo] = useState(null);

    const [presetIndex, setpresetIndex] = useState(0);
    const [ispresetUpload, setIspresetUpload] = useState(false);
    const [presetFile, setpresetFile] = useState(null); // 이미지 스타일 파일obj
    const [share, setShare] = useState(false);

    const [modal, setModal] = useState(consts.defaultModalValue)

    const [calcPoint, setCalcPoint] = useState(0);


    const onMetaData = (metaData) => {
        console.log(metaData)
        setVideoError(false)
        setvideoInfoError(false);
        if (metaData) {
            if (metaData?.height > 1080) {
                setVideoError(true)
                setMediaInfo(null)
            } else {
                let point = getMenu({ idx: 9 })?.point
                let result = metaData.width * metaData.height * metaData.duration / point
                if (result < 1) {
                    result = 1;
                }
                setCalcPoint(Math.floor(Number(result.toFixed(2))));

                setVideoError(false);
                setMediaInfo(metaData)
            }
        } else {
            setVideoError(false)
            setvideoInfoError(true);
            setMediaInfo(null)
        }
    }

    useEffect(() => {
        setMediaInfo(null)
        setCalcPoint(0)
    }, [video])

    // 비디오 만들기
    const makeVideoFunc = () => {

        let sendData = {
            video: video,
            videoInfo: mediaInfo,
            preset: "",
            share: !share
        };

        if (!video) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_video" })
            })
            return;
        }

        if (ispresetUpload) {
            if (!presetFile) {
                setModal({
                    ...modal,
                    open: true,
                    message: getLang({ key: "error_input_preset" })
                })
                return;
            }
            sendData.preset = presetFile
        } else {
            sendData.preset = config.option_mood_style[presetIndex].idx
        }

        console.log("sendData:", sendData);

        // setLoading(true)
        // setTimeout(() => { setLoading(false) }, 1000)
        // return;

        setLoading(true);
        APIS.post("/aiVideo/correction", sendData).then(({ data }) => {
            if (data) console.log("/aiVideo/correction:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }

    const defaultSetOption = (configData) => {
        let error = false

        if (error) setConfigError(error)

        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)

        if (artData?.videoStyle) {
            let dataIndex = configData?.option_mood_style?.findIndex(v => v.value == artData?.videoStyle)
            if (dataIndex >= 0) {
                setpresetIndex(dataIndex)
            }
        } else if (artData?.imageStyleFile) {
            setIspresetUpload(true);
            let imageData = await loadImage(consts.imgUrl + artData?.imageStyleFile)
            setpresetFile(imageData)
        }

    }

    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConifg(data);
            defaultSetOption(data);
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    useEffect(() => {
        configDataFunc();
    }, []);

    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    return (
        <>
            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            <LangText id={getMenu({ idx: 9 }).title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 9 }).info_key} />
                        </p>
                    </div>
                    <div className="thumb">
                        {/* <img src={consts.imgUrl + getMenu({ idx: 9 })?.image?.ko} /> */}
                        <img src={consts.imgUrl + getMenu({ idx: 9 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_upload_video" /></p>
                                <p className="body1"><LangText id="info_upload_mood" /></p>
                                {videoError && <p className="body1 color-red"><LangText id="error_bigsize_image" /></p>}
                                {videoInfoError && <p className="body1 color-red"><LangText id="err_videoinfo_error" /></p>}
                            </div>
                        </div>

                        <InputFileDrag
                            name="drag-file"
                            valid="video"
                            limit={limitSize}
                            setValue={setVideo}
                            onMetaData={onMetaData}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_preset_list" /></p>
                                <p className="body1"><LangText id="info_preset_list" /></p>
                            </div>

                            <Button title={ispresetUpload ? getLang({ key: "btn_show_style" }) : getLang({ key: "btn_upload_image_style" })} type={2} onClick={() => {
                                setIspresetUpload(!ispresetUpload)
                            }} />
                        </div>
                        {!ispresetUpload ? <div className="border_box">
                            <p className="body1"><LangText id="text_style_list" /></p>
                            <RadioImage
                                className="mt-12"
                                options={config?.option_mood_style?.map((v) => {
                                    return { title: getLang({ key: v?.title_key }), imgSrc: `${consts.imgUrl}${v?.imgPath}` }
                                })}
                                current={presetIndex}
                                onChange={setpresetIndex}
                            />
                        </div> : <InputFileDrag
                            name="drag-file-style"
                            setValue={(v) => {
                                setpresetFile(v)
                            }}
                        />}
                    </div>
                </div>



                <div className="confirm_box mt-80">
                    <Button
                        type={4}
                        title={getLang({ key: "btn_create_video", replace: { key: "{0}", val: calcPoint && video ? calcPoint : 0 } })}
                        round
                        onClick={makeVideoFunc}
                        disable={(video && !videoError && !videoInfoError) ? false : true}
                    />
                    <input
                        type="checkbox"
                        id={"checkShare"}
                        className='checkbox5'
                        // checked={false}
                        onChange={(e) => {
                            console.log(e.target.checked)
                        }} />
                    <label className="mt-12" for={'checkShare'}>
                        <LangText id="btn_not_share" />
                    </label>
                </div>
            </div>
        </>
    );
}
